// TODO: compute this in services
export function extendUserProfile( { userProfile, settings = {}, } ) {
	userProfile.settings = settings;

	if ( userProfile.assessments?.DISC ) {
		const { moniker, } = userProfile.assessments.DISC;
		userProfile.assessments.DISC.highType = moniker.substr( 0, 1 );
	}

	return userProfile;
}
